/* document.addEventListener( 'DOMContentLoaded', function() {
  var splide = new Splide( '.splide' );
  splide.mount();
} ); */

class SplideComponent extends HTMLElement {
  connectedCallback() {
    this.initSplide();
  }

  disconnectedCallback() {
    this.destroySplide();
  }

  initSplide() {
    const el = this.querySelector('.splide');
    if (!el) return;

    if (this.splide) return;

    const config = this.getSplideConfig();
    this.splide = new Splide(el, config).mount();
  }

  destroySplide() {
    if (!this.splide) return;
    this.splide.destroy(true);
    this.splide = null;
  }

  getSplideConfig() {
    return {};
  }
}
customElements.define('splide-component', SplideComponent);

/* class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    // Si pas de contrôles, on stoppe
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );

    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );

    this.slider.addEventListener(
      'scroll',
      this.setSlideVisibility.bind(this)
    );

    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = 1000 * this.slider.dataset.speed;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );

    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
}
customElements.define('slideshow-component', SlideshowComponent); */


$(document).ready(function(){
  
  if ($('.tab-content .tabcontent').length > 0) {
    // Tabs events
    $('.tab-nav li:first-child').addClass('active');
    $('.tab-content .tabcontent').hide();
    $('.tab-content .tabcontent:first').show();
    $('.tab-nav li').click(function(e){
        e.preventDefault();   
        $('.tab-nav li').removeClass('active');
        $(this).addClass('active');
        $('.tab-content .tabcontent').hide();
        
        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    }); 
    }
    

    // Social video play
    $('.gdt-video-social').each(function() {
      $(this).on('click', function(event){
        var video = $(this).find("video");
        var play_btn = $(this).find(".gdt-video-social-play");
        video.controls = false;
        if (!video[0].paused){
          video[0].pause();
          play_btn.removeClass("playing"); 
        }
      });
    });
    $('.gdt-video-social .gdt-video-social-play').on('click', function(event){
      var video = $(this).siblings('video')[0];
      event.stopPropagation();
      if (video.paused){
        video.play();
        $(this).addClass("playing");
      } else {
        video.pause();
        $(this).removeClass("playing"); 
      }
    });

    // Social video
    $('.gdt-video .gdt-videos-social').slick({
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '35px',
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 2,
                centerPadding: '0px',
              }
            }
          ]
    });

    // Slides    
    // Testimonials
    $('.gdt-testimonials .testimonials').slick({
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 2,
                arrows: false,
                centerMode: true,
                centerPadding: '35px',
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                arrows: false,
                centerMode: true,
                centerPadding: '25px',
              }
            }
          ]
    });


    // STICKY ATC
    //$(document).ready(function() {
    // Function to check if it's a mobile device
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    var parentOriginalHeight = null;

    function handleStickyButton() {
      var $addToCartButton = $(".followMeSticky"); 
      if ($addToCartButton.length === 0) return;
      var $parentWrapper = $addToCartButton.closest(".product__info-wrapper"); 
      var $parentSection = $addToCartButton.closest("section");

      if (isMobileDevice()) {
        var parentSectionBottom = $parentSection.offset().top + $parentSection.outerHeight();
        var scrollTop = $(window).scrollTop();
        
        if (parentSectionBottom <= scrollTop) {
          parentOriginalHeight = $parentWrapper.outerHeight();
          $parentWrapper.css("min-height", parentOriginalHeight + "px");
          
          $addToCartButton.addClass("sticky-bottom");
          $parentWrapper.removeClass("scroll-trigger");
          
          /* var buttonHeight = $addToCartButton.outerHeight();
          $addToCartButton.css("transform", "translateY(" + buttonHeight + "px)");
          setTimeout(() => {
            $addToCartButton.css("transform", "translateY(0)");
          }); */

        } else {
          $parentWrapper.css("min-height", "");
          $addToCartButton.removeClass("sticky-bottom");
          $parentWrapper.addClass("scroll-trigger");
          $addToCartButton.css("transform", "");
        }

      } else {
          $addToCartButton.removeClass("sticky-bottom");
          /* if (!isButtonSticky) {
              $parentWrapper.addClass("scroll-trigger");
          } */
      }
    }

    $(window).on("scroll", function() {
        handleStickyButton();
    });
  //});

});

gsap.utils.toArray(".comparisonSection.start").forEach(section => {
  let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".gdt_compare_onscroll",
            pin: false,
            markers: false,
            start: "top 20%",
            end: () => "+=" + section.offsetWidth / 1.5, 
            //end: () => "+=" + 100, 
            scrub: true,
            anticipatePin: 0
        },
        defaults: {ease: "none"}
    });
  
  tl.fromTo(section.querySelector(".afterImage"), { xPercent: 100, x: 0}, {xPercent: 0})
    .fromTo(section.querySelector(".afterImage img"), {xPercent: -100, x: 0}, {xPercent: 0}, 0);
}); 


class GdtModalToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick);

    if (!this.dataset.close) {
      this.overlayElem = this.parentNode.querySelector('modal-overlay')
      this.overlayElem.addEventListener('click', this.handleClickOverlay);
    }

  }

  handleClick = (event) => {
    if (!this) {return}
    let modalElem
    let modalId

    if (this.dataset.close) {
      let modalRoot = this.closest('.modal-overlay.open')
      if (modalRoot) {
        modalRoot.classList.remove('open')

        if (!this.dataset.ignoreScroll) {
          document.querySelector('body').classList.remove('overflow-hidden')
        }
      }
      return
    }
    
    modalId = this.dataset.id
    modalElem = document.getElementById(modalId)
    if (!modalElem.classList.contains('open')) {
      // OPEN
      // Overwrite tidio z-index
      $("#tidio-chat iframe").css("z-index","999");
      modalElem.classList.add('open')
      if (!this.dataset.ignoreScroll) {
        document.querySelector('body').classList.add('overflow-hidden')
      }
    } else {
      // CLOSE      
      modalElem.classList.remove('open')
      if (!this.dataset.ignoreScroll) {
        document.querySelector('body').classList.remove('overflow-hidden')
      }
    }
    
  }

  handleClickOverlay = (event) => {
    event.preventDefault()
    if (event.target === this.overlayElem) {
      this.overlayElem.classList.remove('open')
      if (!this.dataset.ignoreScroll) {
        document.querySelector('body').classList.remove('overflow-hidden')
      }
    }
  }

}
customElements.define("gdt-modal", GdtModalToggle);






